import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const isChunkError = (msg) => /Loading chunk|ChunkLoadError|Loading CSS chunk|dynamically imported module/i.test(String(msg || ""));
const recoverFromStaleBundle = () => {
  try {
    const last = Number(sessionStorage.getItem("gu_chunk_reload") || 0);
    if (Date.now() - last < 30000) return;
    sessionStorage.setItem("gu_chunk_reload", String(Date.now()));
  } catch (e) { /* noop */ }
  window.location.reload();
};
window.addEventListener("error", (e) => { if (isChunkError(e?.message)) recoverFromStaleBundle(); });
window.addEventListener("unhandledrejection", (e) => {
  const r = e?.reason;
  if (r && (r.name === "ChunkLoadError" || isChunkError(r.message))) recoverFromStaleBundle();
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
